import axiosPrivate from "../axiosPrivate";
import { GET_REPORTS } from "src/constants";

export const getReports = async (data, config = {}) => {
    const response = await axiosPrivate.post(GET_REPORTS, data, {
        headers: {
            "Content-Type": "application/json",
        },
        ...config,
    });
    return response;
};